import { ref } from 'vue';
import { defineStore } from 'pinia';
import { INameValue } from '@/interfaces/entities/name-value.interface';
import { ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-vue';

export const usePageStore = defineStore('Page', () => {
  const menuOpened = ref(false);
  const homePage = ref({
    name: '',
    value: '',
  });
  const membershipCardModalData = ref<Record<string, Field<string>>>({});
  const breadcrumbs = ref<INameValue[]>([]);

  const toggleMenu = () => {
    menuOpened.value = !menuOpened.value;
  };

  const dataTestId = (rendering: ComponentRendering | undefined) => {
    const cmsDataTestId = rendering?.fields?.dataTestId as Field<string>;
    if (cmsDataTestId?.value) return cmsDataTestId.value;
    return rendering ? `${rendering?.componentName}_${rendering?.uid}` : undefined;
  };

  return {
    homePage,
    breadcrumbs,
    menuOpened,
    membershipCardModalData,
    toggleMenu,
    dataTestId,
  };
});
